import { showTasks } from '@/api/local-material.js'
import { getLocalMaterialStatus } from '@/api/constant'
import { taskProgress } from '@/api/open'

const pageName = 'adx_tasks'

export default {
    name: pageName,
    components: {
    },
    props: {
        showTaskPage: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            data: [],
            loading: false,
            queryParam: {
                name: null,
                url: null,
                date: null,
            },
            columns: [],
            modelSync: {},
            modelFill: {},
            selectedRowKeys: [],
            taskStatus: {},
            showRecordForm: false,
            tableGrid: this.getTableGrid(),
            taskProgress: {
                download_stats: {
                    total: 0,
                    running: 0,
                    completed: 0,
                    pending: 0,
                    failed: 0,
                },
                transcode_stats: {
                    total: 0,
                    running: 0,
                    completed: 0,
                    pending: 0,
                    failed: 0,
                },
                sync_stats: {
                    total: 0,
                    running: 0,
                    completed: 0,
                    pending: 0,
                    failed: 0,
                },
                sync_ks_stats: {
                    total: 0,
                    running: 0,
                    completed: 0,
                    pending: 0,
                    failed: 0,
                },
                sync_ks_local_stats: {
                    total: 0,
                    running: 0,
                    completed: 0,
                    pending: 0,
                    failed: 0,
                },
                sync_organize_stats: {
                    total: 0,
                    running: 0,
                    completed: 0,
                    pending: 0,
                    failed: 0,
                },
            },
            lastUpdateTime: '',
            refreshTimer: null,
        }
    },
    computed: {
        type () {
            const segments = this.$route.path.split('/')
            return segments[segments.length - 1]
        },
        windowWidth(){
			const { windowWidth } = this.$store.state.tabStore;
			return windowWidth;
		},
        downloadProgressPercent() {
            const stats = this.taskProgress.download_stats
            if (!stats.total) return 0
            return Number(((stats.completed + stats.failed) / stats.total * 100).toFixed(1))
        },
        transcodeProgressPercent() {
            const stats = this.taskProgress.transcode_stats
            if (!stats.total) return 0
            return Number(((stats.completed + stats.failed) / stats.total * 100).toFixed(1))
        },
        syncProgressPercent() {
            const stats = this.taskProgress.sync_stats
            if (!stats.total) return 0
            return Number(((stats.completed + stats.failed) / stats.total * 100).toFixed(1))
        },
        syncOrganizeProgressPercent() {
            const stats = this.taskProgress.sync_organize_stats
            if (!stats.total) return 0
            return Number(((stats.completed + stats.failed) / stats.total * 100).toFixed(1))
        },
        syncKsProgressPercent() {
            const stats = this.taskProgress.sync_ks_stats
            if (!stats.total) return 0
            return Number(((stats.completed + stats.failed) / stats.total * 100).toFixed(1))
        },
        syncKsLocalProgressPercent() {
            const stats = this.taskProgress.sync_ks_local_stats
            if (!stats.total) return 0
            return Number(((stats.completed + stats.failed) / stats.total * 100).toFixed(1))
        }
    },
    mounted() {
        this.genTableCol();
        getLocalMaterialStatus().then(res => {
            this.taskStatus = res.data.list || []
        }).finally(() => {
            this.getData()
        })
    },
    methods: {
        genTableCol(){
			this.columns = [
				// { width: isPc?60:50,  type: 'checkbox' ,fixed: 'left'},
				{ minWidth: 120,title: '素材名称', field: 'name', fixed: 'left' },
				{ minWidth: 180,title: '原素材地址', field: 'url', fixed: 'left' },
                { minWidth: 120, title: '状态', slots: { default: 'status' } },
                { minWidth: 120,title: '同步时间', field: 'sync_time'},
			];
			this.tableGrid.columns = this.columns
		},
        getTableGrid() {
            let grid = this.$helper.tableGrid(pageName)
            grid.size = 'medium'
            grid.border = 'inner'
            grid.height = '750'
            return grid
        },
        handleRowChange(result) {
            this.selectedRowKeys = result.records.flatMap((item) => {
                return item.id
            })
            // this.selectedRowKeys = result.records
        },
        handlePageChange(pager) {
            this.tableGrid.pagerConfig.currentPage = pager.currentPage
            this.tableGrid.pagerConfig.pageSize = pager.pageSize
            this.getData()
        },
        handleSortChange(data) {
            this.queryParam.sort_field = data.order ? data.field : null
            this.queryParam.sort_type = data.order
            this.getData()
        },
        getData() {
            this.fetchTaskProgress()

            this.selectedRowKeys = []
            this.tableGrid.loading = true
            const json = Object.assign({}, this.queryParam, {
                page: this.tableGrid.pagerConfig.currentPage,
                page_size: this.tableGrid.pagerConfig.pageSize,
                pid: this.model.pid
            })

            if (json.date && json.date.length > 0) {
                json.started_at = json.date[0].format('YYYY-MM-DD')
                json.finished_at = json.date[1].format('YYYY-MM-DD')
                delete json.date
            }
            showTasks(json).then(res => {
                this.tableGrid.pagerConfig.total = res.data.total
                this.tableGrid.loading = false
                this.tableGrid.data = res.data.list
              
                this.data = res.data.list
            }).catch(() => {
                this.tableGrid.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.tableGrid.pagerConfig.currentPage = 1
            this.getData()
        },
        close() {
            this.$emit('success')
            this.$emit('update:showTaskPage', false)
        },
        resetSearch() {
            this.queryParam = {
                name: null,
                url: null,
                date: null,
            }
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('LocalMaterialController', route)
        },
        onVisibleChange(visible) {
            if (visible) {
                this.startAutoRefresh()
            } else {
                this.stopAutoRefresh()
            }
            this.getData()
        },
        fetchTaskProgress() {
            taskProgress().then(res => { 
                // 使用 Object.assign 合并，保留默认值兜底，防止接口返回缺少字段时报错
                this.taskProgress = Object.assign({}, this.taskProgress, res.data || {})
                this.lastUpdateTime = new Date().toLocaleString()
            })
        },
        startAutoRefresh() {
            this.fetchTaskProgress()
            this.refreshTimer = setInterval(() => {
                this.fetchTaskProgress()
            }, 60000)
        },
        stopAutoRefresh() {
            if (this.refreshTimer) {
                clearInterval(this.refreshTimer)
                this.refreshTimer = null
            }
        },
    },
    beforeDestroy() {
        this.stopAutoRefresh()
    },
    filters: {
        statusColor(status) {
            switch (status) {
                case 2:
                    return 'orange'
                case 3:
                    return 'green'
                default:
                    return ''
            }
        }
    },
}
